import React, { useState, useEffect } from "react";
import { navigate } from "@reach/router";
import NavBar from "./NavBar";

import Progress from "./Progress";

import { useTranslation } from "react-i18next";

import { useSpring, animated } from "react-spring";

import { findVideo } from "./admin/utils";

export default function Content(props) {
  const { t } = useTranslation();

  const [sidebarShow, setSidebarShow] = useState(true);
  const [closeButtonShow, setCloseButtonShow] = useState(false);
  const [contentLabel, setContentLabel] = useState(false);
  const [playerView, setPlayerView] = useState(" normal-width");

  const {
    sections,
    courseSlug,
    idCurrentVideo,
    idCurrentSection,
    progress,
    setState
  } = props;

  const { location } = props;

  useEffect(() => {
    if (sections && location.pathname === `/${courseSlug}`) {
      setState({
        idCurrentVideo: sections[0].videos[0].id,
        idCurrentSection: sections[0].id,
        previousVideo: null,
        previousSection: null,
        nextVideo: sections[0].videos[1].id,
        nextSection: sections[0].id,
        videoUrl: sections[0].videos[0].videoUrl
      });
    }
  }, [courseSlug, location, sections, setState]);

  //animation
  const propsAnimSidebar = useSpring({
    to: {
      opacity: sidebarShow ? 1 : 0,
      transform: sidebarShow
        ? `translate3d(0px, 0, 0)`
        : `translate3d(-300px, 0, 0)`
    },
    from: {
      opacity: 0.2,
      transform: `translate3d(-200px, 0, 0)`
    },

    config: { mass: 5, tension: 500, friction: 80 }
  });

  //Change route
  useEffect(() => {
    const video = findVideo(idCurrentVideo, sections);

    if (idCurrentVideo) {
      navigate(`/${courseSlug}/${video.slug}`);
    }
  }, [idCurrentVideo, courseSlug, sections]);

  const sidebarToggle = () => {
    setSidebarShow(!sidebarShow);
    setContentLabel(false);
  };

  useEffect(
    function handleViewPlayer() {
      if (sidebarShow) {
        setPlayerView(" normal-width");
      } else {
        setPlayerView(" full-width");
      }
    },
    [sidebarShow]
  );

  const closeButtonToggle = newState => {
    setCloseButtonShow(newState);
  };

  const contentLabelOn = () => {
    setContentLabel(true);
  };

  const contentLabelOff = () => {
    setContentLabel(false);
  };

  return (
    <>
      <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap ">
        <span
          className="navbar-brand"
          style={{
            fontSize: "1.5em",
            paddingLeft: "1em"
          }}
        >
          <i className="fas fa-film text-light"></i>
        </span>

        <h1 className="align-items-center pt-2 ml-4 text-light">
          {t(`${props.title}`)}
        </h1>
        <Progress className="align-right" data={progress} />
      </nav>

      <div className="container-fluid">
        <div className="row">
          {sidebarShow ? (
            <animated.div
              style={propsAnimSidebar}
              className=" d-lg-block sidebar px-2"
              onMouseEnter={() => closeButtonToggle(true)}
              onMouseLeave={() => closeButtonToggle(false)}
            >
              <div className="card-header">
                {t("Content")}

                {closeButtonShow ? (
                  <button
                    type="button"
                    className="close-btn btn btn-light  "
                    onClick={sidebarToggle}
                  >
                    <i className="fas fa-times" />
                  </button>
                ) : null}
              </div>

              <NavBar
                handleVideoSelect={props.handleVideoSelect}
                data={sections}
                current={idCurrentVideo}
                idCurrentSection={idCurrentSection}
                routerProps={props}
                sections={sections}
              />
            </animated.div>
          ) : (
            <button
              type="button"
              className="btn btn-light course-content-toggle "
              onClick={sidebarToggle}
              onMouseOver={contentLabelOn}
              onMouseOut={contentLabelOff}
            >
              {contentLabel && t("Show Content")}
              <i className="fas fa-arrow-right" />
            </button>
          )}

          <>
            <div
              className={`container-fluid player-container pt-5 pb-2 ${playerView}`}
            >
              {props.children}
            </div>
          </>
        </div>
      </div>
    </>
  );
}
